<!--eslint-disable-->
<template>
  <div class="navbar">
    <div class="head-title">
      {{ systemName }}
    </div>
    <ul class="shortcut-bar">
        <el-dropdown trigger="click" @command="commandTheme">
          <li class="shortcut-item">
              <div class="icon">
                <svg-icon icon-class="head_theme"/>
              </div>
              <div class="text">
                风格
              </div>
          </li>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="1">暗色</el-dropdown-item>
            <el-dropdown-item :command="2">亮色</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      <li class="shortcut-item">
        <div class="icon">
          <svg-icon icon-class="head_home" @click="onUser()"/>
        </div>
        <div class="text">
          <a href="http://www.szsoling.com/" target="_blank">官网</a>
        </div>
      </li>
      <li class="shortcut-item">
        <div class="icon">
          <svg-icon icon-class="head_help" @click="onUser()"/>
        </div>
        <div class="text" @click="onHelp">
          帮助
        </div>
      </li>
      <li class="shortcut-item header-user-name">
        <div class="icon">
          <!-- <svg-icon v-if="!avatarUrl" class="head-icon-def-user" icon-class="head_user" @click="onUser()"/> -->
          <img :src="avatarUrl" class="head-icon-user">
        </div>
        <div class="header-user-name-text">{{userInfo.realName}}</div>
      </li>
      <li class="shortcut-item exit" @click="logOutFuc">
        <el-tooltip effect="dark" content="登出" placement="bottom">
          <svg-icon class="head-logout" icon-class="logout" @click="logOutFuc()"/>
        </el-tooltip>
      </li>
    </ul>
  </div>
</template>

<script>
/* eslint-disable */
import { confirm } from '@/libs/utils';
import Breadcrumb from '@/layout/components/Breadcrumb/index.vue';
import { mapState } from "vuex";
import store from '@/store';
import pubPath from "@/libs/path";
import userDef from '@/assets/images/common/avatar_def.png'
import Help from './Help';

import { setSkin } from '@/api/service'
export default {
  components: {
    Breadcrumb
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    }),
    systemName() {
      return '索菱官网后台管理系统'
    },
    avatarUrl() {
      // return userDef
      if (!this.userInfo.avatarFilePath) return userDef
      return pubPath.imagePath + this.userInfo.avatarFilePath + '?x-oss-process=image/resize,p_12';
    }
  },
  methods: {
    confirm,
    logOutFuc () {
      this.confirm('确定退出登录？', '登出', () => {
        this.$store.dispatch('logOut').then(() => {
          this.$message.success('成功登出！！！');
          this.$router.push({ name: "login" });
        }).catch(e => {
          this.$router.push({ name: "login" });
          console.log(e)
        })
      });
    },
    // 点击头像
    onUser () {

    },
    onHelp() {
      window.open('/Help-demo.pdf');
      // this.$dialogBox({
      //   title: '帮助文档',
      //   components: Help,
      //   width: 1000
      // });
    },
    commandTheme(type) {
      console.log(type);
      setSkin(type).then(res => {
        if (res.code === 200) {
          // todo change theme
          this.userInfo.skin = type
          store.commit('SET_USER_INFO', this.userInfo)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
